import { createEntityAdapter } from '@ngrx/entity';
import { SocietePatrimoineHierarchieAncetreEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<SocietePatrimoineHierarchieAncetreEntityState>;

export const adapter = createEntityAdapter<SocietePatrimoineHierarchieAncetreEntityState>({
  selectId: o => o.idSocietePatrimoineHierarchieAncetre
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const societePatrimoineHierarchieAncetreFeatureKey = 'societePatrimoineHierarchieAncetre';
